/*
 *   File : chip.js
 *   Author : https://evoqins.com
 *   Description :  chip component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { memo } from 'react';

import LoaderImg from "../../Assets/Images/coloured_loader.svg";

function Loader(props) {
    return (
        <img src={LoaderImg}
            draggable="false"
            alt="loader" />
    );
};

export default memo(Loader);